const METEOALARM_COLORS = {
    l2: '#FFFF00',
    l3: '#FFC500',
    l4: '#FF0000',
}

export {
    METEOALARM_COLORS,
}